export const UNSUPPORTED_FILE_TYPE = "unsupported" as const;

export type FilePreviewType =
  | "pdf"
  | "jpg"
  | "png"
  | typeof UNSUPPORTED_FILE_TYPE;

export interface FilePreviewContentProps {
  fileUrl: string;
  fileName?: string;
  mimeType?: string;
  maxWidth?: number;
  maxHeight?: number;
  isFullScreen?: boolean;
  isScrollLayout?: boolean;
}
